module.exports = __webpack_public_path__ + "img/cockpit_outline.802cbecd.svg";